import type { CurrentUser } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useShouldStartFirstRunExperience } from '@ms/yammer-hooks/dist/firstRunNewUser';
import { useCurrentSessionUserField } from '@ms/yammer-hooks/dist/session';
import { useIsSuggestedActionsLightboxEnabled } from '@ms/yammer-hooks/dist/suggestedActions';
import CurrentPromptCanShow from '@ms/yammer-web-components/dist/dismissablePromptView/CurrentPromptCanShow';
import type { FC } from 'react';
import React from 'react';

import FirstRunExperienceDialog from './LoadableFirstRunExperienceDialog';
import SuggestedActionsLightboxDialog from './SuggestedActionsLightboxDialog';
import { useFreCompletedThisSession } from './useFreCompletedThisSession';

const FirstRunExperience: FC = () => {
  const userPreferences = useCurrentSessionUserField('userPreferences') as CurrentUser['userPreferences'];
  const isSimplifiedFREEnabled = useExperimentTreatmentWithoutReporting('SimplifiedFRE');
  const shouldShowFirstRunModal = useShouldStartFirstRunExperience();
  const shouldShowSuggestedActions = useIsSuggestedActionsLightboxEnabled();

  const { freCompletedThisSession, markFreCompleted } = useFreCompletedThisSession();

  if (userPreferences.webClientPreference !== 'MODERN') {
    return null;
  }

  if (shouldShowFirstRunModal) {
    return (
      <CurrentPromptCanShow promptKey="FirstRunExperience">
        <FirstRunExperienceDialog onComplete={markFreCompleted} />
      </CurrentPromptCanShow>
    );
  }

  const shouldSuppressLightbox = isSimplifiedFREEnabled && freCompletedThisSession;

  return shouldShowSuggestedActions && !shouldSuppressLightbox ? <SuggestedActionsLightboxDialog /> : null;
};

export default FirstRunExperience;
